import { useMemo } from 'react'
import { useBulkActions } from './useBulkActions'
import { bulkActionsRelatedToId } from '../utils'
import { INVOICE_BULK_ACTION_TYPES } from '../bulkActions.constants'

export const useUnreviewedBulkActionsForInvoice = (
  invoiceId: string,
  enabled: boolean
) => {
  const { bulkActions, isLoading } = useBulkActions({
    refetchInterval: enabled ? 2000 : undefined,
    types: INVOICE_BULK_ACTION_TYPES
  })

  const unreviewedBulkActionsForInvoice = useMemo(() => {
    return bulkActionsRelatedToId(bulkActions, invoiceId).filter(
      bulkAction => !bulkAction.reviewedAt
    )
  }, [bulkActions, invoiceId])

  return {
    bulkActions: unreviewedBulkActionsForInvoice,
    isLoading: isLoading
  }
}
